//
import { RForm } from "@/components/reusable_components/next"
import PosPendingSaleService from '@/services/api/POS/PosPendingSale'

//
export default {
  components: {
    RForm,
  },
  data() {
    return {
      loadings: {
        employee: false,
        sales: false,
      },
    }
  },
  methods: {
    
    /**
     *
     */
    onError ( error ) {
      this.$toast.error( error.message )
    },
    
    /**
     *
     */
    onSuccess ( error ) {
      this.$toast.success( error.message )
    },

    /**
     * 
     */
    onCancelSales() {
      this.$toast.confirm( "¿Confirma la eliminación de los tickets pendientes?", this.$toaster( this, this.toCancelSales))
    },

    /**
     * 
     */
    onCancelEmployeeSales() {
      this.$toast.confirm( "¿Confirma eliminar los tickets de empleado pendientes?", this.$toaster( this, this.toCancelEmployeeSales ))
    },

    /**
     * 
     */
    toCancelSales() {
      this.toggleSales()
      PosPendingSaleService.cancel().then(this.onSuccess).catch(this.onError).then(this.toggleSales)
    },
    
    /**
     * 
     */
    toCancelEmployeeSales() {
      this.toggleEmployee()
      return PosPendingSaleService.cancelEmployee().then(this.onSuccess).catch(this.onError).then(this.toggleEmployee)
    },

    /**
     * 
     */
    toggleSales() {
      this.loadings.sales = !this.loadings.sales
    },

    /**
     * 
     */
    toggleEmployee() {
      this.loadings.employee = !this.loadings.employee
    },
  },
  mounted() {
    this.setTitle('Anular tickets')
  },
}